<template>
  <div>
    <div v-show="isLoading">
      <div
        class="loading-page"
        style="background-color: #f7f7f785;"
      >
        <i
          class="fa-spin fas fa-spinner fa-4x"
          style="color: var(--primary);"
        />
      </div>
    </div>
    <div
      v-if="showErro"
      class="w-100 text-center erro-text"
    >
      <h2 class="mb-1">
        Você não tem autorização!
      </h2>
      <p class="mb-2">
        Você não tem permissão para acessar essa página
      </p>
    </div>
    <div v-if="!isLoading && !showErro">
      <div class="card-proposta-doc shadow-sm">
        <h1>Documentos requisitados pela proposta: {{ numeroProposta }}</h1>
        <documentos-proposta-section :proposta-id="proposta.id" />
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/app-modulo/comercial/portal-proposta/shared/services/api'
import apiPessoa from '@/app-modulo/comercial/pessoa/shared/services/api'
import { persistPortalSession, updateAbility } from '@/auth/utils'
import DocumentosPropostaSection from './shared/components/documentos-proposta/DocumentosPropostaSection.vue'

export default {
  components: {
    DocumentosPropostaSection,
  },
  data() {
    return {
      proposta: null,
      numeroProposta: null,
      form: {
        pessoaId: this.$route.query.pessoaId,
        email: this.$route.query.email,
        token: this.$route.query.token,
      },
      isLoading: true,
      showErro: false,
    }
  },
  created() {
    // Lógica de autorização semelhante à LandingPage.vue
    apiPessoa.autorizar(this.form)
      .then(response => {
        persistPortalSession({
          userData: response.data.userData,
          accessToken: response.data.accessToken,
        })
        updateAbility(this.$ability, response.data.userData?.ability)
        this.isLoading = false
        // Não redireciona, apenas libera acesso
        this.carregarProposta()
      })
      .catch(err => {
        this.isLoading = false
        this.showErro = true
        throw err
      })
  },

  methods: {
    carregarProposta() {
      const params = this.$route && this.$route.params ? this.$route.params : {}
      const query = this.$route && this.$route.query ? this.$route.query : {}
      const { propostaId } = params
      // Agora busca numeroProposta da query string
      this.numeroProposta = query.numeroProposta || propostaId || ''
      this.proposta = { id: propostaId }
      if (propostaId) {
        api.getPropostaDocumentos(propostaId)
          .then(({ data }) => {
            const encontrada = data.queryable && data.queryable.length > 0 ? data.queryable[0] : null
            this.proposta = encontrada || { id: propostaId, documentos: [] }
          })
          .catch(() => {
            this.proposta = { id: propostaId, documentos: [] }
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.loading-page {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  z-index: 99999 !important;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .i {
    position: absolute;
    opacity: 1;
  }
}

.erro-text {
  margin-top: 20rem;
}

.card-proposta-doc {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
  padding: 2rem 2.5rem 2.5rem 2.5rem;
  margin: 2.5rem auto 0 auto;
  max-width: 900px;
  min-width: 320px;
  width: 95%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
</style>
